// extracted by mini-css-extract-plugin
export var pillWrapper = "_qg-0";
export var showOverflow = "_qg-1";